'use client';

import { Button } from '@common/components';
import { Pagination } from '@common/components/molecule/Pagination';

interface SearchResultMeta {
  totalCount?: number;
  totalPages?: number;
  hasNext?: boolean;
}

interface SearchSectionShellProps {
  meta?: SearchResultMeta;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  /** 결과 영역(스켈레톤/리스트/빈 상태). 호출자가 isLoading 분기 책임. */
  children: React.ReactNode;
  header?: React.ReactNode;
}

export function SearchSectionShell({
  meta,
  page,
  pageSize,
  onPageChange,
  children,
  header,
}: SearchSectionShellProps) {
  return (
    <section className="flex w-full min-w-0 flex-1 flex-col">
      <div className="flex items-center justify-between py-10 mobile-tablet:px-20">
        <p className="font-700 tracking-[-0.28px] text-Gray-black typo-body4 mobile-tablet:font-500">
          {typeof meta?.totalCount === 'number'
            ? `전체 ${meta.totalCount.toLocaleString()}건`
            : '검색 결과'}
        </p>
        {header}
      </div>

      {/*
       * 결과 영역의 floor는 호출부(카테고리별)에서 결정.
       * 스켈레톤 자연 높이가 카테고리마다 달라(10 카드 × 카드높이) shell이 통일 값을 박으면 CLS 발생.
       */}
      <div className="flex flex-1 flex-col">{children}</div>

      {meta?.totalPages && meta.totalPages > 1 ? (
        <Pagination
          totalCount={meta.totalCount ?? 0}
          currentPage={page}
          size={pageSize}
          onMovePage={onPageChange}
          perButtonCount={5}
          className="my-0 pb-40"
        />
      ) : null}

      {!meta?.totalPages && (page > 1 || meta?.hasNext) ? (
        <div className="flex items-center justify-center gap-8 pb-40 pt-24">
          <Button
            type="button"
            theme="secondary-fill"
            dimensions="H40"
            disabled={page < 2}
            onClick={() => onPageChange(page - 1)}
          >
            이전
          </Button>
          <Button
            type="button"
            theme="primary-fill"
            dimensions="H40"
            disabled={!meta?.hasNext}
            onClick={() => onPageChange(page + 1)}
          >
            다음
          </Button>
        </div>
      ) : null}
    </section>
  );
}
